import React from "react";
import { ENTITY_TYPES } from "../../Components/Sidebar/utils/sidebarStorage";
import LegalOverviewPage from "./LegalOverviewPage";
import SalesOverviewPage from "./components/SalesOverviewPage";

export default function OverviewPage({ onOpenQrAfterGenerate }) {
  const entityType = sessionStorage.getItem("EntityType") || "";

  if (entityType === ENTITY_TYPES.merchant) {
    return <SalesOverviewPage onOpenQrAfterGenerate={onOpenQrAfterGenerate} />;
  }

  return <LegalOverviewPage onOpenQrAfterGenerate={onOpenQrAfterGenerate} />;
}
